import React from 'react'

const RegisterButton = ({ state }) => {
  const { session } = state

  if (session.session_type_key == 'session_type_one_to_one_meeting') {
    return(
      <div className='icon-and-text disabled'>
        <i className='fa fa-minus' aria-hidden='true'></i>
        <span>SELECTED</span>
      </div>
    )
  }
  if (state.evaluationCompleted) {
    return (
      <i className='fa fa-check' aria-hidden='true'></i>
    )
  }
  switch(session.registration_status) {
  case 'un_register':
    return(
      <div className='icon-and-text'>
        <i className='fa fa-minus' aria-hidden='true'></i>
        <span>SELECTED</span>
      </div>
    )
  case 'auto_register':
  case 'register':
    return (
      <div className="icon-and-text">
        <i className="fa fa-plus" aria-hidden="true"></i>
        <span> SPACES <br/>AVAILABLE</span>
      </div>
    )
  case 'session_full':
    return(
      <span className='red'>SESSION FULL</span>
    )
  case 'not_authorized':
    return(
      <span>INVITE REQUIRED</span>
    )
  case 'add_to_agenda':
  case 'double_booked':
    return(
      <div className="icon-and-text">
        <i className="fa fa-plus" aria-hidden="true"></i>
        <span>ADD TO MY<br/>SCHEDULE</span>
      </div>
    )
  case 'register_limited_space':
    return(
      <div className="icon-and-text">
        <i className="fa fa-plus" aria-hidden="true"></i>
        <span>LIMITED SPACE AVAILABLE</span>
      </div>
    )
  }

}

export default RegisterButton